module.exports = __webpack_public_path__ + "files/81c8e15ba01874b1b4ae2a4ee4d2941b.png";